export const COLUMNS_ENUM = Object.freeze({
  PREFIX: { order: 0, name: "Prefix" },
  MAX_LENGTH: { order: 1, name: "Max Length" },
  AS: { order: 2, name: "AS" },
  IP_VERSION: { order: 3, name: "IP Version" },
  MASK_LENGTH: { order: 4, name: "Mask Length" },
  RPKI_ROA_DATASOURCE_ASSOCIATIONS: { order: 5, name: "Source" },
});
